import {RoomType} from '.'

export enum ChannelAction {
    ChannelJoin = 1,
    ChannelJoinRoomOrGame = 2
}

export const PRIMARY_CHANNEL_ACTIONS: readonly ChannelAction[] = [
    ChannelAction.ChannelJoin,
    ChannelAction.ChannelJoinRoomOrGame,
]

export interface SendChannelActionData {
    action: ChannelAction
    payload: unknown
}

export interface ChannelJoinData {
    channelId: string
    username: string
    profilePictureUrl: string
    clientVersion: number
    isInitialLoad: boolean
    roomOrGameId?: string | undefined
}

export interface ChannelJoinRoomOrGameData {
    channelId: string
    roomType: RoomType
}
